<template>
  <div id="app">
    <div class="topTitle">
      <div id="main">
        <img class="logo" :src="total_data.web_logo_left" alt />
        <img class="subTitle" :src="total_data.web_logo_right" alt />
      </div>
    </div>

    <div class="topNav">
      <div id="main">
        <router-link :to="item.link_url" v-for="(item,index) in head_nav" :key="index">
          <!-- <span>{{item.name}}</span> -->

          <span
            style="width:100px;text-align:center;"
            @mouseover="mouseOver(index)"
            @mouseleave="mouseLeave"
          >
            {{item.name}}
            <div
              class="zoujinxinhaitong_div"
              v-if="current_index == index"
              @mouseover="mouseOver(index)"
              @mouseleave="mouseLeave"
            >
              <router-link
                :to="{path:child_item.link_url,query:child_item.link_url.id}" @click.native="refresh"
                v-for="child_item in item.child"
                :key="child_item.id"
                @mouseover="mouseOver(index)"
                @mouseleave="mouseLeave"
              >
                <div>{{child_item.name}}</div>
              </router-link>
            </div>
          </span>
        </router-link>
      </div>
    </div>
    <router-view />

    <div class="footer">
      <div id="main">
        <div class="footer_item" v-for="(item,index) in total_data.bottom_nav" :key="index">
          <router-link :to="item.link_url">
            <div class="item_title">{{item.name}}</div>
          </router-link>

          <router-link
            :to="nav_item.link_url"
            v-for="(nav_item,nav_index) in item.child"
            :key="nav_index"
          >
            <div class="item_inner">* {{nav_item.name}}</div>
          </router-link>
        </div>

        <img :src="total_data.bottom_picture" alt />
      </div>

      <div class="bottom_div">©2020 {{total_data.site_name}} <a style="color:#FFF" href="https://beian.miit.gov.cn" target="_blank">{{total_data.site_beian}}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data:function() {
    return {
      total_data: "", // 总数据
      current_nav_id: 0,

      path: "", // 需要隐藏公共组件的路径
      head_nav: [],
      current_index: -1
    };
  },
  methods: {
    mouseOver:function(index) {
      this.current_index = index;
    },
    mouseLeave:function() {
      this.current_index = -1;
    },
    refresh:function() {
      this.$router.go(0)
    }
  },
  mounted:function() {
    // 获取app.vue页面数据，logo,备案号等
    this.$fetch("index/commonConfig").then(res => {
      if (res.code == 1) {
        // console.log(res);
        this.head_nav = res.data.head_nav;
        this.total_data = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
  }
};
</script>
<style scoped>

.topTitle {
  width: 100%;
  height: 100px;
  /* background-color: aqua; */
}
.topTitle .logo {
  width: 470px;
  height: 55px;
  margin-top: 20px;
}
.topTitle .subTitle {
  width: 270px;
  height: 60px;
  float: right;
  margin-top: 20px;
}
.topNav {
  background-color: #0e05d0;
  height: 50px;
  width: 100%;
  box-sizing: border-box;
}
.topNav span {
  display: inline-block;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  line-height: 50px;
  margin-right: 50px;
  box-sizing: border-box;
  height: 100%;
}
/* .topNav span:hover {
  border-bottom: 3px solid #fff;
} */
.footer {
  background-color: #303030;
  height: 600px;
  width: 100%;
  color: #fff !important;
  position: relative;
}
.footer .footer_item {
  float: left;
  margin-right: 50px;
  font-family: SimHei;
}
.footer .footer_item .item_title {
  font-size: 20px;
  margin: 30px 0 30px 0;
  font-weight: 500;
  color: #fff;
}
.footer .footer_item .item_inner {
  font-size: 18px;
  margin-top: 15px;
  color: #fff;
}
.footer img {
  width: 250px;
  height: 460px;
  float: right;
  margin-top: 30px;
}
.bottom_div {
  height: 60px;
  width: 100%;
  border-top: 2px solid #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  line-height: 60px;
}
.zoujinxinhaitong_div {
  position: absolute;
  margin-left: -50px;
  width: 200px;
  background-color: #fff;
  z-index: 20;
  font-size: 16px;
}
.zoujinxinhaitong_div div {
  width: 100%;
  text-align: center;
}
.zoujinxinhaitong_div div:hover {
  background-color: #e8e8e8;
}
</style>
<style>
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}
body {
  background: #fff;
  color: #555;
  font-size: 16px;
  font-family: Verdana, Arial, Helvetica, sans-serif;
}
td,
th,
caption {
  font-size: 14px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}
a {
  color: #555;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
img {
  border: none;
  /* 清除img标签留白 */
  vertical-align: middle;
}
ol,
ul,
li {
  list-style: none;
}
input,
textarea,
select,
button {
  font: 14px Verdana, Helvetica, Arial, sans-serif;
}
table {
  border-collapse: collapse;
}
html {
  overflow-y: scroll;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
#main {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box !important;
}
.back_to_index {
  width: 32px;
  height: 50px;
  float: right;
  margin-top: -10px;
  margin-left: 20px;
}

/* swiper样式 */
.swiper-container {
  width: 100% !important;
  margin-bottom: 40px !important;
  padding: 20px 0 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  border-top: 1px solid #e8e8e8 !important;
}
.swiper-wrapper {
  width: 20% !important;
}
.swiper-slide {
  width: 95% !important;
  margin-right: 5% !important;
}
.swiper-slide:last-child {
  margin-right: 0 !important;
}
.swiper-slide div {
  /* width: 100%; */
  padding: 30px 0px;
  background-color: #e8e8e8;
  border-radius: 20px;
}
.swiper-slide div .img {
  width: 100%;
  height: 80px;
  background-color: #e8e8e8;
  object-fit: scale-down !important;
  background-size: 100% 100% ;
}
</style>



// WEBPACK FOOTER //
// src/App.vue